//Copyright (c) 2022 Panshak Solomon

import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { createTheme, ThemeProvider } from "@material-ui/core";
import { createStore, applyMiddleware, compose } from "redux";
import { Provider } from "react-redux";
import thunk from "redux-thunk";
import reducers from "./reducers/";
import { AppProvider } from "./Context/AppContext";
import { EditProvider } from "./Context/EditContext";
import { ItemProvider } from "./Context/ItemContext";
import { StatsProvider } from "./Context/StatsContext";
import { CurrencyProvider } from "./Context/CurrencyContext";
import { CartProvider } from "./Context/CartContext";

const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
  palette: {
    primary: {
      main: "#ef7f1a",
    },
  },
});
const store = createStore(reducers, compose(applyMiddleware(thunk)));

ReactDOM.render(
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      <AppProvider>
        <EditProvider>
          <ItemProvider>
            <StatsProvider>
              <CurrencyProvider>
              <CartProvider>
                
                <App />
                
                </CartProvider>
              </CurrencyProvider>
            </StatsProvider>
          </ItemProvider>
        </EditProvider>
      </AppProvider>
    </ThemeProvider>
  </Provider>,
  document.getElementById("root")
);
